import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LiftStateService {
  apiUrl: string;
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl + 'api/LiftModuleState';
  }

  getState(liftId: number, params: HttpParams) {
    const url = this.apiUrl + '/' + String(liftId);

    return this.httpClient.get<any>(url);
  }
}
